import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronDown_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L16 20.5858L27.2929 9.29289C27.6834 8.90237 28.3166 8.90237 28.7071 9.29289C29.0976 9.68342 29.0976 10.3166 28.7071 10.7071L16.7071 22.7071C16.3166 23.0976 15.6834 23.0976 15.2929 22.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289Z"
            />
        </SvgStyled>
    );
};

export default ChevronDown_lg;
